module.exports = __webpack_public_path__ + "img/LUB00420.2bc81479.png";